export default "__VITE_ASSET__DXGHiaaQ__"